var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterHorizontal = function SvgFilterHorizontal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2 4.667h4.667m0 0a2 2 0 0 0 2 2h.666a2 2 0 0 0 0-4h-.666a2 2 0 0 0-2 2Zm4 6.666H14m-.667-6.667H14M2 11.334h2m0 0a2 2 0 0 0 2 2h.667a2 2 0 0 0 0-4H6a2 2 0 0 0-2 2Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterHorizontal);
export default ForwardRef;